import { agentHubRollout, canReadAgentSelector } from '@lumapps/agent-hub/ducks/selectors';
import { createSelector } from '@lumapps/redux/reselect';

import { GlobalAgentChatState } from '../types';

const globalAgentChatSelector = (state: FrontOfficeStore | BackOfficeStore): GlobalAgentChatState | undefined =>
    state.agentChat;

/**
 * Retrieves whether the global agent chat is accessible to the current user: the Agent Hub FF
 * must be on AND the user must have the `canReadAgent` permission.
 */
export const canAccessAgentChatSelector = createSelector(
    agentHubRollout.isGA,
    canReadAgentSelector,
    (isEnabled, hasAgentReadPermission) => isEnabled && hasAgentReadPermission,
);

export const isChatOpenedSelector = createSelector(globalAgentChatSelector, (agentChat) => agentChat?.isChatOpen);

export const selectedChatAgentSelector = createSelector(
    globalAgentChatSelector,
    (agentChat) => agentChat?.selectedAgent,
);
export const pendingAgentChangeSelector = createSelector(
    globalAgentChatSelector,
    (agentChat) => agentChat?.pendingAgentChange,
);

export const agentContextSelector = createSelector(globalAgentChatSelector, (agentChat) => agentChat?.agentContext);
